import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';

import {Alert, Button, Carousel, Col, Form, Jumbotron, Row} from 'react-bootstrap';
import {calcArea, priceCalc} from './price';
import ItemSelector from './ItemSelector';
import {InputCustom} from './InputCustom';
import {BASE_S2} from "../const";

const ItemShape = ({item, onChange}) => {
    const buttons = [
        {label: 'Квадрат', value: 'square'},
        {label: 'Прямоугольник', value: 'rectangle'},
        {label: 'Круг', value: 'circle'},
        {label: 'Овал', value: 'oval'},
        {label: 'Готовые этикетки', value: 'etiketka'},
        {label: 'Другое', value: 'other'},
    ];
    return (
        <>
            <ItemSelector
                item={item}
                values={buttons}
                name='shape'
                title='Выберите форму'
                onChange={onChange}/>
        </>);
};


const Other = ({options}) => {
    return (<div>
        <p className='p-5 text-center'> Свяжитесь с нами удобным для вас образом ({options.phone} или {options.email}) -
            мы напечатаем для
            вас
            самоклеящиеся
            этикетки <strong>любой формы</strong>.
        </p>
        <p className='p-5 text-center'>
            <img src='https://zapadbaltobuv.ru/image/cache/catalog/promotions/znachok-akcija-png-2-500x500.png'
                 style={{width: '500px', maxWidth: '100%'}}/>
            <img src='https://cdn.freelance.ru/img/portfolio/pics/00/11/90/1151166.jpg'
                 style={{width: '500px', maxWidth: '100%'}}/>
            <img src='https://image.freepik.com/free-vector/_23-2147783979.jpg'
                 style={{width: '500px', maxWidth: '100%'}}/>
        </p>
    </div>);
};


const Corners = ({item, onChange}) => {
    let options = [];
    for (let i = 1; i <= item.width / 2; i++) {
        options.push(<option key={i} selected={i === item.radius}>{i}</option>);
    }

    return (
        <>
            <h4>Радиус скругления углов(мм)</h4>
            <Row>
                <Col xs={12} sm={6}>
                    <Form.Group controlId='radius'>
                        <Form.Control
                            as='select'
                            size='lg'
                            value={item.radius}
                            onChange={e => onChange({...item, ...{radius: e.currentTarget.value}})}>
                            {options}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                    <p>Пример использования радиуса скругления</p>
                    {[1, 2, 3, 5, 8, 12].map((e) => {
                        return <div key={e} style={{
                            display: 'inline-block',
                            marginRight: '10px',
                            marginBottom: '10px',
                            width: '120px',
                            height: '120px',
                            borderRadius: e + 'mm',
                            border: '1px solid #f58682',
                        }}><h4 style={{padding: '40px 0', textAlign: 'center'}}>{e}мм</h4></div>
                    })}
                </Col>
            </Row>
        </>);
};

const ItemSizes = ({item, options, onChange}) => {
    let labelW = 'Ширина';
    labelW = item.shape === 'circle' ? 'Диаметр' : labelW;
    labelW = item.shape === 'oval' ? 'Диаметр1' : labelW;

    let labelH = 'Высота';
    labelH = item.shape === 'oval' ? 'Диаметр2' : labelH;
    let visibleH = item.shape !== 'square' && item.shape !== 'circle';

    return (
        <>
            <h4>Размер этикетки (мм)</h4>
            <Row>
                <Col xs={12} sm={6}>
                    <InputCustom name={'width'}
                                 value={item.width}
                                 label={labelW}
                                 maxLength={3}
                                 min={10}
                                 max={options.width}
                                 onChange={width => onChange({...item, width})}/>
                </Col>
                <Col xs={12} sm={6}>
                    {visibleH && <InputCustom name={'height'}
                                              value={item.height}
                                              label={labelH}
                                              maxLength={3}
                                              min={10}
                                              max={options.height}
                                              onChange={height => onChange({...item, height})}/>}
                </Col>
            </Row>
        </>);
};

const PaperType = ({item, options, onChange}) => {
    const square = calcArea(item);
    const papers = [
        {label: 'Полуглянцевая бумага', value: 'glossy_photo_paper'},
        {label: 'Полуматовая бумага', value: 'matte_paper'},
        {label: 'Белая плёнка', value: 'glossy_film'},
        {label: 'Прозрачная плёнка', value: 'transparencies'},
        {label: 'Золотая плёнка', value: 'gold_film'},
        {label: 'Серебряная плёнка', value: 'silver_film'},
    ];
    const papers2 = [
        {label: 'Полуглянцевая бумага', value: 'semi_glossy_photo_paper_2'},
        {label: 'Полуматовая бумага', value: 'matte_paper_2'},
        {label: 'Белая плёнка', value: 'white_film_2'},
        {label: 'Прозрачная плёнка', value: 'transparencies_2'},
        {label: 'Золотая плёнка', value: 'gold_film_2'},
        {label: 'Серебряная плёнка', value: 'silver_film_2'},
    ];

    return (
        <>
            <ItemSelector
                item={item}
                values={square > 8 ? papers2 : papers}
                name='paper'
                title='Выберите тип бумаги'
                description={options['desc_' + item.paper]}
                onChange={onChange}/>
        </>);
};

const Distance = ({item, onChange}) => {
    return (
        <Row>
            <Col xs={12} sm={6}>
                <Form.Group controlId='distance'>
                    <Form.Label>Расстояние между этикетками в рулоне (мм)</Form.Label>
                    <Form.Control
                        as='select'
                        size='lg'
                        onChange={e => onChange({...item, ...{distance: e.currentTarget.value}})}>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                        <option>11</option>
                        <option>12</option>
                        <option>13</option>
                        <option>14</option>
                        <option>15</option>
                    </Form.Control>
                </Form.Group>
            </Col>
            <Col xs={12} sm={6}></Col>
        </Row>
    );
};

const Laminate = ({item, onChange}) => {
    const papers = [
        {label: 'Матовая ламинация', value: 'mate_laminate'},
        {label: 'Глянцевая ламинация', value: 'glance_laminate'},
        {label: 'Ламинация не нужна', value: 'no'},
    ];

    return (
        <>
            <ItemSelector
                item={item}
                values={papers}
                name='laminate'
                title='Нужна ламинация?'
                description='(улучшает водостойкие свойства этикетки и прочность к истиранию)'
                onChange={onChange}/>
        </>);
};

const Direction = ({item, onChange}) => {
    const papers = [
        {label: 'Не важно', value: 'not-important'},
        {label: 'Важно', value: 'important'},
    ];
    const description = item.direction === 'important'
        ? <p className={'bold'}>Опишите, как должны располагаться этикетки в рулоне в Пояснении внизу после оформления
            заказа.<br/>Или отправьте нам схему или фото расположения этикеток в рулоне на электронную почту вместе с
            оригинал-макетом, ответом на письмо, полученное после оформления заказа</p>
        : '';

    return (
        <>
            <ItemSelector
                item={item}
                values={papers}
                name='direction'
                title='Направление этикеток в рулоне'
                message={description}
                onChange={onChange}/>
        </>);
};

const SleeveSize = ({item, onChange}) => {
    const papers = [
        {label: 'Втулка 40 мм', value: 'Втулка 40 мм'},
        {label: 'Втулка 76 мм', value: 'Втулка 76 мм'},
        {label: 'Листы', value: 'Листы'},
    ];

    return (
        <>
            <ItemSelector
                item={item}
                values={papers}
                name='sleeve'
                title='Способ упаковки'
                description='Намотать на втулку или нарезать листами (удобно для небольшого тиража)'
                onChange={onChange}/>
        </>);
};

const Colors = ({item, onChange}) => {
    const variants = [
        {label: 'Цветное изображение (CMYK)', value: 'cmyk'},
        {label: 'Чёрно-белое изображение (Black)', value: 'black'},
    ];

    return (
        <>
            <ItemSelector
                item={item}
                values={variants}
                name='color'
                title='Цветность оригинал-макета этикетки'
                description=''
                onChange={onChange}/>
        </>);
};


const Counts = ({item, onChange}) => {
    return (
        <>
            <ItemSelector title='Количество этикеток'>
                <InputCustom name={'counts'}
                             value={item.counts}
                             min={1}
                             max={10000000}
                             maxLength={8}
                             onChange={counts => onChange({...item, counts})}/>
            </ItemSelector>
        </>);
};

const UploadFile = ({item, options, onChange}) => {
    const size = Math.floor((item.file ? item.file.size : 0) / 1000000);
    return (
        <>
            <ItemSelector title='Файл с дизайном этикетки'>
                <p style={{fontSize: '12px'}}>На сайте Вы можете прикрепить превью, фото или оригинал-макет в форматах
                    png, jpg, pdf или cdr весом не более 8 МБ.
                    Оригинал-макет в форматах eps, ai, tiff высылайте после оформления заказа на наш
                    e-mail: {options.email} с указанием номера заказа, во время заказа прикрепляйте превью или фото</p>
                {item.fileError && <Alert variant='danger'>
                    <Alert.Heading>Ошибка</Alert.Heading>
                    <p>Необходимо приложить файл с макетом-дизайном</p>
                </Alert>}
                {size > 8 && <Alert variant='danger'>
                    <Alert.Heading>Ошибка</Alert.Heading>
                    <p>Файл слишком большой (больше 8 Мб)</p>
                </Alert>}
                <br/>
                {(!item.file || size > 8) && <Form.File
                    id='custom-file'
                    key={Date.now()}
                    onChange={e => onChange({...item, ...{file: e.target.files[0], fileError: null}})}
                />}
                <br/>
                {item.file && (size <= 8) &&
                <Alert variant='dark' onClose={() => onChange({...item, ...{file: null}})} dismissible>
                    <Alert.Heading>Ваш файл</Alert.Heading>
                    <p> {item.file.name}</p>
                </Alert>}
                <p>
                    <br/>
                    <a href="/maket-requirements/" target="_blank">Требования к макету</a>
                </p>
            </ItemSelector>
        </>);
};

const Price = ({items, item, options, onAdd, onChange}) => {
    const price = priceCalc(item, options);
    const onAddPress = () => {
        onAdd({...item});
        onChange({...item, ...{file: null}})
    };
    return (
        <>
            {price > 200000 &&
            <div style={{padding: '20px 0px', fontSize: '130%', fontWeight: 'bold', color: '#1c1b1b'}}>Сумма заказа превышает 200 000 руб.
                Мы готовы предоставить Вам индивидуальную скидку
                после ознакомления с макетом и техническим заданием. Отправьте информацию на электронную
                почту <a href="mailto:info@etiketki.online">info@etiketki.online</a> или позвоните по номеру
                8-800-200-27-31.</div>}

            <Jumbotron style={{padding: 10, textAlign: 'center'}}>
                <Row>
                    <Col>
                        <h4>Стоимость: {Math.round(price)} ₽ (цена за одну
                            ~{Math.floor(priceCalc(item, options) * 100 / item.counts) / 100} ₽)</h4>
                        Доставка компанией СДЭК - 490 рублей в любой город России.<br/>
                        <Button variant='success'
                                size='lg'
                                onClick={onAddPress}>
                            {items.length > 0 ? 'Добавить к заказу' : 'Продолжить'}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <strong>
                            Если у Вас возникли вопросы, позвоните нам по телефону <nobr>{options.phone}</nobr><br/> или
                            напишите на электронную почту {options.email}
                        </strong>
                    </Col>
                </Row>
            </Jumbotron></>);
};

const EtiketkaSelector = ({etiketkis, onChange}) => {
    return (
        <>
            <Carousel interval={null} className="pt-1 pb-1">
                {etiketkis.map((e, index) =>
                    <Carousel.Item key={index}>
                        <div style={{
                            backgroundImage: `url(${e.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: isMobile ? '750px' : '550px'
                        }} className="w-100">
                        </div>
                        <Carousel.Caption style={{left: '10%', right: '10%'}}>
                            <h3 style={{color: '#fff'}}>{e.name}</h3>
                            <h5 style={{color: '#fff'}}>{e.description}</h5>

                            <div className={isMobile ? 'p-0' : 'pt-2 pb-2'}>
                                <a style={{minWidth: '50%'}} className='' href={e.image}
                                   target="_blank">Посмотреть
                                    пример</a>
                                <br/>
                                <br/>
                                {e.prices.map((item, index) => (
                                    <div key={index}>
                                        <Button onClick={() => onChange({...item, ...e})}
                                                variant='danger'
                                                size='lg'
                                                style={{minWidth: '50%'}}>Заказать {item.counts} наклеек
                                            за {item.price} ₽</Button>
                                        <br/>
                                        <br/>
                                    </div>
                                ))}
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>
                )}
            </Carousel>
        </>
    )
};


const DEFAULT_ITEM = {
    shape: 'square',
    width: 100,
    height: 100,
    paper: 'semi_glossy_photo_paper_2',
    laminate: 'no',
    sleeve: 'Втулка 76 мм',
    file: null,
    corner: 'rounded',
    radius: 2,
    color: 'cmyk',
    counts: 2000,
    distance: 5,
    direction: 'not-important',
    etiketkaId: null,
    delivery: 'cdek'
};

const OrderItem = ({items, etiketkis, options, onAdd}) => {
    const [item, setItem] = useState({...DEFAULT_ITEM});
    const changeItem = (i) => {
        const fixed = {...i};
        if (i.shape === 'square' || i.shape === 'circle') {
            fixed.height = fixed.width;
        }
        setItem(fixed);
    };
    const changeCounts = (i) => {
        const s1 = calcArea(item);
        const s2 = calcArea(i);
        if ((s1 > BASE_S2 && s2 > BASE_S2) || (s1 < BASE_S2 && s2 < BASE_S2)) {
            changeItem(i);
        } else if (s2 < BASE_S2) {
            i.paper = 'glossy_photo_paper';
            changeItem(i);
        } else {
            i.paper = 'semi_glossy_photo_paper_2';
            changeItem(i);
        }
    }

    const notOther = item.shape !== 'other';
    const other = item.shape === 'other';
    const etiketka = item.shape === 'etiketka';

    return (
        <>
            <ItemShape item={item} onChange={changeItem}/>
            {other && <Other options={options}/>}
            {etiketka && <EtiketkaSelector etiketkis={etiketkis} onChange={onAdd}/>}
            {notOther && !etiketka && <ItemSizes item={item} options={options} onChange={changeItem}/>}
            {notOther && !etiketka && (item.shape === 'square' || item.shape === 'rectangle') &&
            <Corners item={item} onChange={changeItem}/>}
            {notOther && !etiketka && <Colors item={item} onChange={changeItem}/>}
            {notOther && !etiketka && <Counts item={item} onChange={changeCounts}/>}
            {notOther && !etiketka && <PaperType item={item} options={options} onChange={changeItem}/>}
            {notOther && !etiketka && <Laminate item={item} onChange={changeItem}/>}
            {notOther && !etiketka && <SleeveSize item={item} onChange={changeItem}/>}
            {notOther && !etiketka && item.sleeve !== 'Листы' && <Direction item={item} onChange={changeItem}/>}
            {notOther && !etiketka &&
            <Price items={items} item={item} options={options} onAdd={onAdd} onChange={changeItem}/>}
        </>);
};

export default OrderItem;
